import React from 'react'

function Terms(props) {
  return (
    <svg stroke={props.stroke} fill={props.fill} stroke-width="0" version="1.1" id="mdi-format-list-checks" viewBox="0 0 24 24" class={props.className} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z"></path></svg>
  )
}

export default Terms
